<rt-select
  [hasSearch]="false"
  [options]="options"
  [optionTemplate]="optionTemplate"
  [triggerTemplate]="triggerTemplate"
  [formControl]="$any(inviteMethodControl())"
  [virtualScrollEnabled]="false"
/>

<ng-template #optionTemplate let-option="option" let-selectedOption="selectedOption">
  <div class="item-container">
    <div class="text-container">
      <div class="badge-container">
        <span class="heading">{{ option.heading }}</span>
        @if (option.badgeText) {
          <rt-badge [text]="option.badgeText" color="warning" iconName="report-problem" />
        }
      </div>
      <span class="subheading">{{ option.subheading }}</span>
    </div>
    @if (selectedOption.value === option.value) {
      <rt-icon name="check" colorToken="colorIconSuccessDefault" />
    }
  </div>
</ng-template>

<ng-template
  #triggerTemplate
  let-selectedOption="selectedOption"
  let-toggleDropdown="toggleDropdown"
  let-dropdownOpened="dropdownOpened"
>
  <div class="input-wrapper">
    <rt-input
      rt-overlay-origin
      [value]="selectedOption.value"
      [displayedValue]="selectedOption.label"
      [hasDropdownIndicator]="true"
      [class.dropdownOpened]="dropdownOpened"
      (click)="toggleDropdown()"
      [readOnly]="true"
    />
  </div>
</ng-template>
